import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { AddCircleOutlined, EditOutlined } from "@mui-symbols-material/w300"
import type { FC, MouseEvent } from "react"

interface WarehouseRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  isActive: boolean
  isOpen: boolean
  canChangeStatus: boolean
  onEditDialogOpen: (e: MouseEvent<HTMLLIElement>) => void
  onStatusToggle: (e: MouseEvent<HTMLLIElement>) => void
}

const WarehouseRowDropdownMenu: FC<WarehouseRowDropdownMenuProps> = ({
  anchorEl,
  canChangeStatus = false,
  isOpen,
  isActive,
  onClose,
  onEditDialogOpen,
  onStatusToggle,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={isOpen} onClose={onClose} data-test='warehouse-row-dropdown-menu'>
      <MenuItem onClick={onEditDialogOpen} data-test='warehouse-edit-menu-item'>
        <ListItemIcon>
          <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Edit' />
      </MenuItem>
      <MenuItem disabled={canChangeStatus} onClick={onStatusToggle} data-test='warehouse-update-status-menu-item'>
        <ListItemIcon>
          <AddCircleOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary={isActive ? "Deactivate" : "Activate"} />
      </MenuItem>
    </Menu>
  )
}

export default WarehouseRowDropdownMenu
